import { Calendar, MapPin, Shirt } from "lucide-react";
import { useGroomMode } from "../../context/GroomModeContext";
import GroomNote from "./GroomNote";
import {
  CEREMONY_DATE_TEXT,
  CEREMONY_LOCATION_TEXT,
  CEREMONY_TIME_TEXT,
  DRESS_CODE_TEXT,
  VENUE_INTRO_TEXT,
} from "../../constants/siteContent";

const DETAILS = [
  {
    icon: Calendar,
    title: "Date & Time",
    detail: (
      <>
        {CEREMONY_DATE_TEXT}
        <br />
        {CEREMONY_TIME_TEXT}
      </>
    ),
    groom: "Yes it's a Saturday, 4pm. Take the weekend off — I'll be stress-sweating from about 7:00 AM.",
  },
  {
    icon: MapPin,
    title: "Location",
    detail: CEREMONY_LOCATION_TEXT,
    groom: "Far enough from Sydney that your phone won't work. This is a feature, not a bug.",
  },
  {
    icon: Shirt,
    title: "Dress Code",
    detail: DRESS_CODE_TEXT,
    groom: "Anything fancier than what I normally wear to Bunnings. Which, to be fair, is a low bar.",
  },
];

export default function VenueInfo() {
  const groomMode = useGroomMode();

  return (
    <section id="venue" className="venue-info" aria-labelledby="venue-heading">
      <div className="section-inner">
        <h2 id="venue-heading" className="section-heading">
          The Venue
        </h2>
        <p className="section-lead">{VENUE_INTRO_TEXT}</p>

        <div className="venue-cards">
          {DETAILS.map(({ icon: Icon, title, detail, groom }) => (
            <div key={title} className="venue-card">
              <Icon className="venue-card-icon" aria-hidden="true" />
              <h3 className="venue-card-title">{title}</h3>
              <p className="venue-card-detail">{detail}</p>
              {groomMode && <GroomNote note={groom} />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
